import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import PropTypes from "prop-types";
import { TextInput, Image } from "hesus-ui-kit";
import ErrorPopUp from "../ErrorPopUp/ErrorPopUp";
import editIcon from "@icons/ic-edit-blue.svg";
import yesIcon from "@icons/ic-green-edit.svg";
import cancelIcon from "@icons/ic-edit-cancel.svg";
import {
  CommentSection,
  CommentWrapper,
  Comment,
} from "./ContextualComment.styled";

const ContextualComment = (props) => {
  const { t, koStatus, isAuthorizedSalesman } = props;
  const [isEdit, setEditStatus] = useState(false);
  const [comment, updateComment] = useState("");
  const [oldComment, setOldComment] = useState("");
  const [isCommentUpdating, setCommentUpdateStatus] = useState(false);
  const [showErrorPopup, setErrorPopupvisibility] = useState(false);
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    updateComment(props.comment);
    setOldComment(props.comment);
  }, [props.comment]);

  const onChange = (e) => {
    updateComment(e.target.value);
  };

  const onEdit = () => {
    setEditStatus(true);
  };

  const onClose = () => {
    setEditStatus(false);
    updateComment(oldComment);
  };

  const onSubmit = () => {
    setCommentUpdateStatus(true);
    setErrorPopupvisibility(false);
    setApiError("");
    axios
      .put(`/sites/${props.jobsite_id}/updateKoComment`, {
        koComment: comment,
      })
      .then(function (response) {
        if (window.__DEV__) {
          console.info("KO: Comment added successfully", response);
        }
        setCommentUpdateStatus(false);
        setEditStatus(false);
        setOldComment(comment);
        // Save comment in local state to show in quote tab.
        props.updateContextComment(comment);
      })
      .catch((err) => {
        if (window.__DEV__) {
          console.error("KO: Error while adding comment", err.response);
        }
        setCommentUpdateStatus(false);
        setEditStatus(false);
        updateComment(oldComment);
        setErrorPopupvisibility(true);
        setApiError(
          err?.response?.data?.message
            ? props.t(err.response.data.message)
            : props.t("KICK_OFF_ERROR_BOX_CONTENT")
        );
      });
  };

  const closePopup = () => {
    setErrorPopupvisibility(false);
    setApiError("");
  };

  return (
    <CommentSection>
      <CommentWrapper>
        {!isEdit && (
          <>
            <Comment>
              {comment ||
                t("KICK_OFF_PAGE_SITE_INFO_HELPTEXT_CONTEXTUAL_COMMENT")}
            </Comment>
            {koStatus !== 3 && isAuthorizedSalesman === 1 && (
              <Image
                src={editIcon}
                alt={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE")}
                title={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE")}
                onClick={onEdit}
                styles={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
            )}
          </>
        )}
        {isEdit && (
          <>
            <TextInput
              type="textarea"
              className="quote_comment"
              label=""
              name="quote_contextual_comment"
              id="quote_contextual_comment"
              isFloat
              onChange={onChange}
              placeholder={t(
                "KICK_OFF_PAGE_SITE_INFO_HELPTEXT_CONTEXTUAL_COMMENT"
              )}
              value={String(comment)}
              errorStyles={{ "font-style": "italic" }}
              containerStyles={{ marginTop: "1px", width: "95%" }}
              inputStyles={{
                border: "1px solid #fff !important;",
              }}
              error=""
            />

            <div>
              {!isCommentUpdating && (
                <>
                  <Image
                    src={yesIcon}
                    alt={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE")}
                    title={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_SAVE")}
                    onClick={onSubmit}
                    styles={{
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                      marginRight: "5px",
                    }}
                  />
                  <Image
                    src={cancelIcon}
                    alt={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_CANCEL")}
                    title={t("KICK_OFF_PAGE_SITE_INFO_FORM_BUTTON_CANCEL")}
                    onClick={onClose}
                    styles={{
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                    }}
                  />
                  {isCommentUpdating && (
                    <ClipLoader size={20} color="#1bace4" />
                  )}
                </>
              )}
            </div>
          </>
        )}
      </CommentWrapper>

      {showErrorPopup && (
        <ErrorPopUp
          title={props.t("KICK_OFF_ERROR_BOX_TITLE")}
          btnText={props.t("KICK_OFF_ERROR_BOX_OK")}
          message={apiError}
          onOkClick={closePopup}
        />
      )}
    </CommentSection>
  );
};

ContextualComment.propTypes = {
  comment: PropTypes.string.isRequired,
  koStatus: PropTypes.number.isRequired,
  isAuthorizedSalesman: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ContextualComment);
